/**
 * An index after which the autoload should start.
 * @type {number}
 */
export const LOAD_MORE_BREAKPOINT = 4;
